import { useProfileStore } from '../stores/profileStore';

export const useProfile = () => {
  const profile = useProfileStore((state) => state.profile);
  const setProfile = useProfileStore((state) => state.setProfile);
  const clearProfile = useProfileStore((state) => state.clearProfile);
  const isProfileLoaded = useProfileStore((state) => state.isProfileLoaded());

  return {
    profile,
    isLoaded: isProfileLoaded,
    setProfile,
    clearProfile,
  };
};
